export const ACTIVE_ORGANISATION_SESSION_KEY = 'wingit:active-organisation-id';
export const ORGANISATION_SELECTION_KEY_PREFIX = 'wingit:selected-organisation:';
export const ACTIVE_ORGANISATION_REQUEST_HEADER = 'x-wingit-organisation-id';

export function getOrganisationSelectionStorageKey(userId) {
  return `${ORGANISATION_SELECTION_KEY_PREFIX}${userId}`;
}

export function getActiveOrganisationId() {
  if (typeof window === 'undefined') {
    return '';
  }

  return String(
    window.sessionStorage.getItem(ACTIVE_ORGANISATION_SESSION_KEY) || ''
  ).trim();
}

export function setActiveOrganisationSelection(userId, organisationId) {
  if (!userId || !organisationId) {
    throw new Error('A signed-in user and organisation are required for selection.');
  }

  const selectedId = String(organisationId);
  window.sessionStorage.setItem(
    getOrganisationSelectionStorageKey(userId),
    selectedId
  );
  window.sessionStorage.setItem(ACTIVE_ORGANISATION_SESSION_KEY, selectedId);
}

export function clearActiveOrganisationId() {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(ACTIVE_ORGANISATION_SESSION_KEY);
  }
}
